<template>
  <div>
    <div v-show="isDetail" class="detail">
      <div class="nav">
        <div class="nav-l">
          <div class="nav-l-tab" :class="{ isActive: activeTab === item.type }" v-for="item in tabs" :key="item.id"
            @click="changeTab(item.type)">
            <template v-if="item.show">
              {{ item.name }}
            </template>
          </div>
        </div>
        <div class="nav-r">
          <el-button style="margin-right:1rem" v-if="isBack" @click="goBack">返回</el-button>
          <el-button :loading="lockNext" v-if="isShow" :disabled="!this.leads.lastPageId"
            @click="onNext">下一条</el-button>
        </div>
      </div>
      <div class="tabs">
        <template v-if="activeTab === 'basic'">
          <div class="header">
            <div class="header-left">
              <div class="heard">
                <span class="heard-label">负责人：</span>
                <span class="heard-name">
                  {{ leads.owner_name }}
                </span>
              </div>
              <div v-if="leads.follow_time === leads.createtime">
                最近跟进时间： <span class="red">暂无</span>
              </div>
              <div v-else>
                最近跟进时间：<span class="red"> {{ leads.follow_time }}</span>
              </div>
            </div>

          </div>
          <div class="tabs-container">
            <p class="detail-title">基本信息</p>
            <el-form v-if="leads" ref="ruleForm" label-width="120px" label-position="left">
              <template v-for="item of forms">
                <el-form-item v-if="item.type === 'el-input'" :label="item.label" :required="item.required"
                  :key="item.id">
                  <template v-if="item.prop === 'front_owner_name'">
                    <div class="ipt" :title="leads.front_owner_name" v-if="editState === 'readonly'">
                      {{ leads.front_owner_name }}
                    </div>
                    <div v-else class="el-input is-disabled el-input--suffix" :style="item.style" style="width: 217px">
                      <span class="el-input__inner">
                        {{ leads.front_owner_name }}
                      </span>
                    </div>
                  </template>
                  <template v-else-if="item.prop === 'owner_name'">
                    <div class="ipt" :title="leads.owner_name" v-if="editState === 'readonly'">
                      {{ leads.owner_name }}
                    </div>
                    <div v-else class="el-input is-disabled el-input--suffix" style="width: 217px" >
                      <span class="el-input__inner"  :style="item.style" >
                        {{ leads.owner_name }}
                      </span>
                    </div>
                  </template>
                  <template v-else-if="item.prop === 'corp_full_name'">
                    <div class="ipt" :title="leads.corp_full_name" v-if="editState === 'readonly'">
                      {{ leads.corp_full_name }}
                    </div>
                    <div v-else>
                      <el-input style="width: 217px" clearable v-model="leads.corp_full_name">
                      </el-input>
                    </div>
                  </template>
                  <template v-else-if="item.prop === 'description'">
                    <div class="ipt" :title="leads.description" v-if="editState === 'readonly'">
                      {{ leads.description }}
                    </div>
                    <div v-else>
                      <el-input clearable v-model="leads.description">
                      </el-input>
                    </div>
                  </template>
                  <template v-else-if="item.prop === 'remark'">
                    <div class="ipt" :title="leads.remark" v-if="editState === 'readonly'">
                      {{ leads.remark }}
                    </div>
                    <div v-else>
                      <el-input clearable v-model="leads.remark">
                      </el-input>
                    </div>
                  </template>
                  <template v-else-if="item.prop === 'detail_address'">
                    <div class="ipt" v-if="editState === 'readonly'" :title="leads.detail_address">{{
                      leads.detail_address
                    }}</div>
                    <el-input v-else v-model="leads[item.prop]" :placeholder="item.placeholder"
                      :disabled="!item.placeholder" :style="item.style" :clearable="item.clearable">
                      <el-button slot="append" icon="el-icon-map-location" @click="toMap()"></el-button>
                    </el-input>
                  </template>
                  <template v-else-if="item.prop === 'remark_mobiles'">
                    <template v-for="(p, idx) of leads[item.prop]">
                      <div class="phone-line" :key="idx">
                        <div class="ipt" v-if="editState === 'readonly'">{{
                          p.tel
                        }}</div>
                        <template v-else>
                          <el-input v-model="leads[item.prop][idx].tel" :placeholder="item.placeholder"
                            :disabled="!item.placeholder" :style="item.style" @blur="onCheckTel(leads[item.prop][idx])"
                            :clearable="item.clearable"></el-input>
                          <el-button :disabled="nolength"  class="add-btn" icon="el-icon-zoom-out"
                            @click="delPhone(leads[item.prop], idx)"></el-button>
                          <el-button  class="add-btn" icon="el-icon-zoom-in"
                            @click="addPhone()"></el-button>
                          <p v-if="leads[item.prop][idx].code == 99" style="color: #f56c6c; margin-left: 20px">
                            <i class="el-icon-error" style="margin-right: 4px"></i>
                            <span>{{ leads[item.prop][idx].errorMsg }}</span>
                          </p>
                          <p v-if="leads[item.prop][idx].code == 1" style="color: #67c23a; margin-left: 20px">
                            <i class="el-icon-success" style="margin-right: 4px"></i>
                            <span>{{ leads[item.prop][idx].errorMsg }}</span>
                          </p>
                        </template>
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <div class="ipt" :title="leads[item.prop]" v-if="editState === 'readonly'">{{
                      leads[item.prop]
                    }}</div>
                    <el-input v-else v-model="leads[item.prop]" style="width: 217px" :placeholder="item.placeholder"
                      :disabled="!item.placeholder" :style="item.style" :clearable="item.clearable"></el-input>
                  </template>
                </el-form-item>
                <el-form-item v-if="item.type === 'el-selecte'" :label="item.label" :required="item.required"
                  :key="item.id">
                  <el-select v-if="editState === 'readonly'" v-model="leads[item.prop]" :placeholder="item.placeholder"
                    disabled="true" :clearable="item.clearable">
                    <el-option v-for="i of item.options" :key="i.id" :label="i.text" :value="i.value"></el-option>
                  </el-select>
                  <el-select v-else v-model="leads[item.prop]" :placeholder="item.placeholder"
                    :disabled="!item.placeholder" :clearable="item.clearable">
                    <el-option v-for="i of item.options" :key="i.id" :label="i.text" :value="i.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="item.type === 'el-date-picker'" :label="item.label" :required="item.required"
                  :key="item.id">
                  <div class="ipt" :title="leads[item.prop]" v-if="editState === 'readonly'">{{
                    leads[item.prop]
                  }}</div>
                  <el-date-picker v-else v-model="leads[item.prop]" type="date" :placeholder="item.placeholder"
                    :disabled="!item.placeholder" :clearable="item.clearable" format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd" @change="handleDateChange"></el-date-picker>
                </el-form-item>
              </template>
            </el-form>
            <el-divider></el-divider>
            <p class="detail-title" style="margin-top:40px">自定义字段信息</p>
            <form-create :title="yulanform" v-model="yulanform" :rule="formrule" :class="selfLock ? 'selfLock' : ''"
              :option="option" @on-submit="onSubmit1" style="width: 80%;margin-top: 20px;"></form-create>
          </div>

        </template>
        <record v-if="activeTab === 'record'" ref="record" :showRecordBtn="showRecordBtn" :data="leads" types="leads">
        </record>
        <logger v-if="activeTab === 'log'" :data="leads" types="leads"></logger>
        <contact v-if="activeTab === 'relevant'" :contactEditBtn="contactEditBtn" :data="leads" types="leads"
          ref="relevant"></contact>
        <div v-if="activeTab === 'chat'">
          <chat v-if="external_userid" :owner="leads.owner" :owner_name="leads.owner_name" :name="leads.name"
            :external="external_userid"></chat>
        </div>
      </div>
      <div class="detail-bottom" v-if="activeTab === 'basic'">
        <div class="header-right">
          <div class="head-menu">
            <div class="head-menu-left">
              <el-button type="primary" v-if="editBtn" @click="onEdit">
                <i class="iconfont iconbanji"></i> 编辑
              </el-button>
              <el-button type="primary" v-if="saveBtn" :disabled="lockSave" @click="onSave">
                <i class="iconfont iconbaocun"></i>
                保存
              </el-button>
              <el-button type="primary" v-if="is_lock" :disabled="lockOther" @click="unLock">
                <i class="iconfont iconjiesuo1"></i>
                解锁
              </el-button>
              <el-button type="primary" class="btn-big" v-if="trasnOtherBtn" :disabled="lockOther" @click="transToOther">
                <i class="iconfont iconzhuanranggai"></i>
                转给他人
              </el-button>
              <el-button type="primary" class="btn-big" v-if="transPoolBtn" :disabled="lockPool" @click="transPool">
                <i class="iconfont iconzhuanyixiansuochi"></i>
                投入线索池
              </el-button>
              <el-button type="primary" class="btn-big" v-if="trasnCustomerBtn" :disabled="lockCustomer"
                @click.native="transCustomer">
                <i class="iconfont iconzhuanhuaweikehu"></i>转化为客户
              </el-button>
              <el-button type="primary" class="btn-big" v-if="mergeBtn" :disabled="lockMerge" @click="handleMergeClues">
                <i class="iconfont iconhebing"></i>
                合并线索
              </el-button>
              <el-button type="primary" class="btn-big" v-if="mergeBtn" :disabled="lockMergeClient"
                @click="handleMergeClient">
                <i class="iconfont iconhebingkehu-01"></i>
                合并客户
              </el-button>
            </div>
            <div class="head-menu-right"></div>
          </div>
        </div>
      </div>
      <el-dialog title="此线索已掉入线索池，复制前往搜索" :close-on-click-modal="false" :visible.sync="onSubmitss" width="20%"
        :show-close="false">
        <div class="abude">
          <p>姓名：{{ value4.name }}</p>
          <p>电话：{{ value4.mobile }}</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="onSure">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 联系人选择组件 -->
      <mail-list v-if="leads" ref="drawer" :module="module" :userid="leads.owner" :id="leads.id"
        :selectionDepartment="selectionDepartment" @handleSelect="handleSelect"></mail-list>
      <!-- 转化客户模块 -->
      <customer-add ref="customerAdd" :customerData="leads"></customer-add>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import record from "@/components/Record";
import logger from "@/components/Logger";
import contact from "@/components/Contact";
import mailList from '@/components/drawer/mailList';
import customerAdd from "@/views/customer/add";
import chat from "@/components/chat/index";
import {
  readLeads,
  saveLeads,
  mergeRelevance,
  delLeadsOnCustomer,
  unlock,
} from "@/api/clues";
import { transferUser, putIntoSea, checkPhone } from "@/api/common";
import { getFieldConfigsEdit } from "@/api/user";
export default {
  name: "cluesDetail",
  inject: ["reload"],
  components: {
    record,
    logger,
    contact,
    mailList,
    customerAdd,
    chat,
  },
  provide() {
    return {
      delBtn: false,
    };
  },
  data() {
    return {
      selectionDepartment: true,
      userid: "",
      activeTab: "basic",
      headMenuShow: true,
      editBtn: true,
      saveBtn: true,
      addBtn: false,
      trasnOtherBtn: true,
      transPoolBtn: true,
      trasnCustomerBtn: true,
      mergeBtn: true,
      showRecordBtn: true,
      contactEditBtn: true,
      module: "",
      search: "",
      leads: {},
      forms: [],
      value4: [],
      onSubmitss: false,
      editState: "readonly",
      mailListShow: false,
      if_leader: false,
      lockSave: true,
      lockOther: false,
      lockPool: false,
      lockCustomer: false,
      lockMerge: false,
      lockMergeClient: false,
      lockNext: false,
      external_userid: "",
      is_lock: false,
      tabs: [
        {
          id: 1,
          name: "基本信息",
          type: "basic",
          show: true,
        },
        {
          id: 2,
          name: "跟进记录",
          type: "record",
          show: true,
        },
        {
          id: 3,
          name: "操作日志",
          type: "log",
          show: true,
        },
        {
          id: 4,
          name: "相关联系人",
          type: "relevant",
          show: true,
        },
        {
          id: 5,
          name: "聊天记录",
          type: "chat",
          show: false,
        },
      ],
      mLong: "",
      mLat: "",
      yulanform: "",
      formrule: [],
      option: {
        submitBtn: {
          show: false,
        },
      },
      fie: [],
      custom_field: {},
      selfLock: true,
      qiyedata: '',
    };
  },
  computed: {
    isDetail() {
      return this.$route.name === "cluesDetail";
    },
    isShow() {
      return this.$route.query.warning != 1
    },
    isBack() {
      return this.$store.state.user.userInfo.type == 1;
    },
    nolength() {
      // let i
      // this.forms.map((item, index) => {
      //   if (item.label === '联系电话') {
      //     i = index
      //   }
      // })
      //this.forms[i].default_val
      let a
      if(this.leads.remark_mobiles.length==1){
        a = true
      }
      return a;
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === "map") {
      next(vm => {
        vm.editState = "edit";
        if (vm.$route.params.address) {
          let timer = setTimeout(() => {
            clearTimeout(timer)
            vm.leads.detail_address = vm.$route.params.address;
          }, 500)
          vm.mLong = vm.$route.params.long;
          vm.mLat = vm.$route.params.lat;
        } else {
          vm.mLong = vm.leads.long;
          vm.mLat = vm.leads.lat;
        }
      });
    } else {
      next(vm => {
        vm.editState = "readonly";
        //vm.getLeads();

      });
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true; // 给列表(list.vue)页面设置keepAlive
    next();
  },

  async mounted() {

    this.getUserid();
    await this.getConfigs();
    await this.getLeads();
    if (this.$store.state.app.clues) {
      if (
        this.$store.state.app.clues.owner !==
        this.$store.state.user.token.userid
      ) {
        this.if_leader = true;
        this.isLeader();
      }
    }
    this.changeLockNext();
    console.log(this.forms)
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getUserid() {
      if (this.$store.state.app.clues) {
        this.userid = this.$store.state.app.clues.owner;
      } else {
        this.userid = this.$store.state.user.token.userid;
      }
    },
    async onCheckTel(obj) {
      try {
        const res = await checkPhone({
          account_id: this.$store.state.user.token.account_id,
          remark_mobiles: obj.tel,
          leads_id: this.$route.params.id,
        });
        obj.errorMsg = res.msg;
        obj.code = res.code;
      } catch (error) {
        console.log(error);
      }
    },
    async getConfigs() {
      const res = await getFieldConfigsEdit({
        account_id: this.$store.state.user.token.account_id,
        userid: this.$store.state.user.token.userid,
        state: "leads"
      });
      let all_field = res.data.start_merge_field;
      this.forms = all_field.filter(item => {
        return item.prop
      });

    },
    async getLeads() {
      const leads = await readLeads({
        account_id: this.$store.state.user.token.account_id,
        // userid: this.userid,
        userid: this.$store.state.user.token.userid,
        id: this.$route.params.id,
        warning: this.$route.query.warning,
        page: this.$route.query.page,
        number_page: this.$route.query.number_page,
        if_leader: this.$route.query.ifLeader,
      });
      let arr = []
      this.formrule = []
      this.custom_field = leads.data.self_content;
      for (let i in this.custom_field) {
        arr.push(this.custom_field[i])
      }
      arr.forEach(item => {
        if (!item.if_show) {
          item.display = item.if_show
        }
      })
      this.formrule = arr;
      if (leads.code == 5) {
        // this.$message({
        //   message: leads.msg,
        // });
        this.onSubmitss = true;
        this.value4 = leads.data;
      }
      if (leads.data.remark_mobiles.length) {
        leads.data.remark_mobiles = leads.data.remark_mobiles.map((i) => {
          return {
            tel: i,
            errorMsg: "",
            code: 0,
          };
        });
      }
      this.leads = leads.data;
      this.external_userid = this.leads.external_userid;
      if (this.external_userid) {
        this.tabs[4].show = true;
        this.$forceUpdate();
      }
      if (leads.data.is_lock == 1) {
        return (this.is_lock = true);
      }
      this.lockNext = false;
    },
    async onSave() {
      let arr = JSON.parse(JSON.stringify(this.forms))
      let mobiles;
      for (const item of arr) {
        if (item.required) {
          if (!this.leads[item.prop]) {
            //以下判断是因为性别选择增加了未知项，而它的值为 0 ，所以需要判断
            if (this.leads[item.prop] === 0) {
              this.leads[item.prop] = 0;
            } else {
              this.$message.error(`${item.label}不能为空！`);
              return;
            }
          }
          if (item.prop === "remark_mobiles") {
            let pro = this.leads.remark_mobiles[0]
            if (pro.tel) {
              mobiles = this.leads.remark_mobiles.map((m) => {
                return m.tel;
              });
            } else {
              this.$message.error(`${item.label}不能为空！`);
              return;
            }
          }
        }
      }
      let selfSub = {}
      for (let i in this.custom_field) {
        this.fie.push(i)
      }
      for (let i = 0; i < this.fie.length; i++) {
        for (let j = 0; j < this.formrule.length; j++) {
          if (this.formrule[j].field == this.fie[i]) {
            this.$set(selfSub, this.fie[i], this.formrule[j])
          }
        }
      }
      const leads = Object.assign(this.leads, {
        account_id: this.$store.state.user.token.account_id,
        userid: this.userid,
        long: this.mLong,
        lat: this.mLat,
        remark_mobiles: mobiles,
        detail_address_name: this.$route.params.address,
        self_content: JSON.stringify(selfSub)
      });
      const res = await saveLeads(leads);
      if (res.code == 1) {
        this.$message({
          type: "success",
          message: res.msg,
        });
        this.getLeads();
        this.editState = "readonly";
        this.selfLock = true
        this.lockSave = true;
      } else {
        if (this.leads.remark_mobiles.length) {
          this.leads.remark_mobiles = this.leads.remark_mobiles.map((i) => {
            return {
              tel: i,
              errorMsg: "",
              code: 0,
            };
          });
        }
      }
    },
    //解锁
    async unLock() {
      const res = await unlock({
        account_id: this.$store.state.user.token.account_id,
        type: "leads",
        id: this.$route.params.id,
        page: this.$route.query.page,
        number_page: this.$route.query.number_page,
      });
      if (res.code == 1) {
        this.$message({
          type: "success",
          message: res.msg,
        });
        this.reload();
      }
    },
    async transPool() {
      // 投入线索池
      this.$confirm("您确定将此线索投入线索池吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(async () => {
          this.lockPool = true;
          let res = await putIntoSea({
            account_id: this.$store.state.user.token.account_id,
            userid: this.leads.owner,
            type: 1,
            id: this.leads.id,
            owner: this.leads.owner,
            owner_name: this.leads.owner_name,
          });
          if (res.code === 1) {
            this.$message({
              type: "success",
              message: "投入成功!",
            });
            this.$router.go(-1);
          } else {
            this.lockPool = false;
          }
        })
        .catch(() => { });
    },
    transToUser(person) {
      if (person.name == undefined) {
        this.$message({
          type: "info",
          message: "请选择名称",
        });
        return
      }
      this.$confirm(`您确定转让此线索吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(async () => {
          this.lockOther = true;
          let res = await transferUser({
            account_id: this.$store.state.user.token.account_id,
            userid: this.leads.owner,
            type: 1,
            id: this.leads.id,
            owner: person.userid,

          });
          if (res.code === 1) {
            this.$message({
              type: "success",
              message: "转让成功!",
            });
            this.$router.go(-1);
          } else {
            this.lockOther = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    mergeClues(person) {
      this.$confirm(`您确定合并此线索吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(async () => {
          this.lockMerge = true;
          let res = await mergeRelevance({
            account_id: this.$store.state.user.token.account_id,
            userid: this.leads.owner,
            leads_id: this.leads.id,
            wleads_id: person.id,
          });
          if (res.code === 1) {
            this.$message({
              type: "success",
              message: "绑定成功!",
            });
            this.$router.go(-1);
          } else {
            this.lockMerge = false;
          }
        })
        .catch(() => { });
    },
    async mergeClient(person) {
      if (person.name == undefined) {
        this.$message({
          type: "info",
          message: "请选择名称",
        });
        return
      }
      this.$confirm(`您确定将此线索合并到 ${person.name} 吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(async () => {
          this.lockMergeClient = true;
          const res = await delLeadsOnCustomer({
            account_id: this.$store.state.user.token.account_id,
            leads_id: this.leads.id,
            customer_id: person.id,
          });
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: "合并成功!",
            });
            this.$router.go(-1);
          }
          this.lockMergeClient = false;
        })
        .catch(() => { });
    },
    handleSelect(person) {
      if (person.name == undefined) {
        this.$message({
          type: "info",
          message: "请选择名称",
        });
        return
      }
      // 转移给他人
      if (this.module === "getAddressBook") {
        this.transToUser(person);
      }
      // 合并线索
      if (this.module === "getNoRelevance") {
        this.mergeClues(person);
      }
      // 合并客户
      if (this.module === "customerList") {
        this.mergeClient(person);
      }
    },
    transToOther() {
      this.module = "getAddressBook";
      this.selectionDepartment = true;
      this.$refs.drawer.open();
    },
    async transCustomer() {
      // 转化客户
      this.lockCustomer = true;
      await this.$refs.customerAdd.open();
      this.lockCustomer = false;
    },
    handleMergeClues() {
      this.module = "getNoRelevance";
      this.selectionDepartment = false;
      this.$refs.drawer.open();
    },
    handleMergeClient() {
      this.module = "customerList";
      this.selectionDepartment = false;
      this.$refs.drawer.open();
    },
    onNext() {
      this.lockNext = true;
      if (!this.leads.lastPageId) {
        this.$message("没有下一条了");
        this.lockNext = false;
        return;
      }
      this.$router.push({
        name: "cluesDetail",
        params: {
          id: this.leads.lastPageId,
        },
        query: {
          page: this.leads.currentPage,
          number_page: this.leads.number_page,
          ifLeader: this.$route.query.ifLeader,
        },
      });
    },
    changeLockNext() {
      this.lockNext = false;
    },
    onSure() {
      this.onSubmitss = false;
      this.$router.push({ name: "cluesPool" });
    },
    changeTab(type) {
      this.activeTab = type;
      this.initBtn();
    },
    onSearch() {
      switch (this.activeTab) {
        case "record":
          this.$refs.record.onSearch(this.search);
          break;
        default:
          this.$refs.relevant.onSearch(this.search);
          break;
      }
    },
    isLeader() {
      // 领导查看视图
      this.editBtn = false;
      this.saveBtn = false;
      this.addBtn = false;
      this.delBtn = false;
      if (this.activeTab === "basic") {
        this.trasnOtherBtn = true;
        this.transPoolBtn = true;
      } else {
        this.trasnOtherBtn = false;
        this.transPoolBtn = false;
      }
      this.trasnCustomerBtn = false;
      this.mergeBtn = false;
      this.showRecordBtn = false;
      this.contactEditBtn = false;
    },
    initBtn() {
      switch (this.activeTab) {
        case "basic":
          this.headMenuShow = true;
          if (this.if_leader) {
            this.isLeader();
          } else {
            this.editBtn = true;
            this.saveBtn = true;
            this.addBtn = false;
            this.delBtn = false;
            this.trasnOtherBtn = true;
            this.transPoolBtn = true;
            this.trasnCustomerBtn = true;
            this.mergeBtn = true;
          }
          break;
        case "record":
          this.headMenuShow = true;
          if (this.if_leader) {
            this.isLeader();
          } else {
            this.editBtn = false;
            this.saveBtn = false;
            this.addBtn = false;
            this.delBtn = false;
            this.trasnOtherBtn = false;
            this.transPoolBtn = false;
            this.trasnCustomerBtn = false;
            this.mergeBtn = false;
          }
          break;
        case "log":
          this.headMenuShow = true;
          if (this.if_leader) {
            this.isLeader();
          } else {
            this.editBtn = false;
            this.saveBtn = false;
            this.addBtn = false;
            this.delBtn = false;
            this.trasnOtherBtn = false;
            this.transPoolBtn = false;
            this.trasnCustomerBtn = false;
            this.mergeBtn = false;
          }
          break;
        case "relevant":
          this.headMenuShow = true;
          if (this.if_leader) {
            this.isLeader();
          } else {
            this.editBtn = false;
            this.saveBtn = false;
            this.addBtn = true;
            if (this.$store.state.user.userInfo.contracts_delete === 1) {
              // 后台权限控制删除按钮
              this.delBtn = true;
            } else {
              this.delBtn = false;
            }
            this.trasnOtherBtn = false;
            this.transPoolBtn = false;
            this.trasnCustomerBtn = false;
            this.mergeBtn = false;
          }
          break;
        case "chat":
          this.headMenuShow = false;
          break;
        default:
          break;
      }
    },
    onEdit() {
      this.editState = "edit";
      this.lockSave = false;
      this.selfLock = false;
    },
    addPhone() {
      console.log(this.leads.remark_mobiles)
      this.leads.remark_mobiles.push({
        tel: "",
        errorMsg: "",
        code: 0,
      });
    },
    delPhone(arr, index) {
      if (arr.length === 1) {
        arr[0] = {
          tel: "",
          errorMsg: "",
          code: 0,
        };
        arr.push();
        return;
      }
      arr.splice(index, 1);
    },
    toMap() {
      this.$router.push({
        name: "map",
        params: {
          ifLeader: 0,
          number_page: 20,
          page: "1",
          id: this.$route.params.id,
        },
      });
    },
    async getField() {
      const res = await this.axios({
        url: "/crm/ApplyExpense/get_custom_filed",
        method: "POST",
        data: {
          account_id: this.$store.state.user.token.account_id,
          state: "leads"
        }
      })
      if (res.code == 1) {
        let obj = res.data.custom_field;
        for (let i in obj) {
          this.formrule.push(obj[i])
        }
      }
    },
    onSubmit1(formData) {
      alert(JSON.stringify(formData));
    },
    handleDateChange(val) { //不用转换
      this.qiyedata = val

    }
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/detail.scss";

::v-deep .el-input__inner {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.phone-line {
  margin: 0 0 10px 20px;
  display: flex;
  .el-button{
    margin-right: 0 !important;
  }
}

.phone-line:nth-child(1) {
  margin-left: 0px;
}

.add-btn {
  margin-left: 10px;
  height: 100%;
}

.selfLock {
  pointer-events: none;
}

.ipt {
  text-overflow: ellipsis;
  word-break: break-all;
}

.el-form-item {
  display: inline-table;
}
</style>
